<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
      
        <header class="modal-header" id="modalTitle">
          <h2><slot name="modalName">
            This is the default title!
          </slot>
           <button v-if="showCloseIcon" type="button" class="btn-close" @click="close" aria-label="Close modal">x</button></h2>
           <slot name="modalHeaderText">
           <div></div>
           </slot>
        </header>
        
        <section class="modal-body" id="modalDescription">
          <slot name="modalBody">
            I'm the default body!
          </slot>
        </section>
        
        <footer class="modal-footer">
          <slot name="modalFooter">

            <button type="button" @click="close" aria-label="Close modal">
              Close</button>
          </slot>
        </footer>
        
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:1000;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow: auto;
    //display: flex;
    //flex-direction: column;
    width:90vw;
    max-height:90vh;
    
    @media (max-width:1440px) {
    	max-width:1000px;
    }
    
  }

.modal-header {
 	padding: 15px;
    border-bottom: 1px solid #eeeeee;
    
    button {float:right; margin-top:-3.5rem;}
    h2 {margin:0.65rem 0 1rem;}
    
    
  }
  .modal-footer {
  	padding: 15px;
    border-top: 1px solid #eeeeee;
    display:flex;
    justify-content: flex-end;
    align-content:center;
  }
  .modal-body {
  padding:15px; 
  
   /* 
 position: relative;
    padding: 20px 10px;
 */
 }
  .btn-close {
    border: none;
    padding: .75rem 1rem;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }
  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }

</style>

<script>
  export default {
    name: 'modal',

    props: {
      showCloseIcon: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
